
// @ts-nocheck


export const localeCodes =  [
  "nl",
  "en",
  "de"
]

export const localeLoaders = {
  "nl": [{ key: "../../node_modules/.pnpm/@bttr-nl+nuxt-layer-base@1.0.0-rc.4_nuxt@3.15.4_rollup@4.34.8_tailwindcss@app+@formkit+themes_v2tyvbaulfakoomues5gcm6yja/node_modules/@bttr-nl/nuxt-layer-base/locales/nl.json", load: () => import("../../node_modules/.pnpm/@bttr-nl+nuxt-layer-base@1.0.0-rc.4_nuxt@3.15.4_rollup@4.34.8_tailwindcss@app+@formkit+themes_v2tyvbaulfakoomues5gcm6yja/node_modules/@bttr-nl/nuxt-layer-base/locales/nl.json" /* webpackChunkName: "locale____w_gfh_corporate_gfh_corporate_nuxt_node_modules__pnpm__64bttr_nl_43nuxt_layer_base_641_0_0_rc_4_nuxt_643_15_4_rollup_644_34_8_tailwindcss_64app_43_64formkit_43themes_v2tyvbaulfakoomues5gcm6yja_node_modules__64bttr_nl_nuxt_layer_base_locales_nl_json" */), cache: true },
{ key: "../../node_modules/.pnpm/@bttr-nl+nuxt-layer-sofie@1.0.0-rc.4_nuxt@3.15.4_react-dom@18.3.1_react@18.3.1_rollup@4.34.8__rquqcm4x5zb2wmahh2kq2ufif4/node_modules/@bttr-nl/nuxt-layer-sofie/locales/nl.json", load: () => import("../../node_modules/.pnpm/@bttr-nl+nuxt-layer-sofie@1.0.0-rc.4_nuxt@3.15.4_react-dom@18.3.1_react@18.3.1_rollup@4.34.8__rquqcm4x5zb2wmahh2kq2ufif4/node_modules/@bttr-nl/nuxt-layer-sofie/locales/nl.json" /* webpackChunkName: "locale____w_gfh_corporate_gfh_corporate_nuxt_node_modules__pnpm__64bttr_nl_43nuxt_layer_sofie_641_0_0_rc_4_nuxt_643_15_4_react_dom_6418_3_1_react_6418_3_1_rollup_644_34_8__rquqcm4x5zb2wmahh2kq2ufif4_node_modules__64bttr_nl_nuxt_layer_sofie_locales_nl_json" */), cache: true },
{ key: "../translations/nl-NL.json", load: () => import("../translations/nl-NL.json" /* webpackChunkName: "locale____w_gfh_corporate_gfh_corporate_nuxt_website_translations_nl_NL_json" */), cache: true }],
  "en": [{ key: "../../node_modules/.pnpm/@bttr-nl+nuxt-layer-base@1.0.0-rc.4_nuxt@3.15.4_rollup@4.34.8_tailwindcss@app+@formkit+themes_v2tyvbaulfakoomues5gcm6yja/node_modules/@bttr-nl/nuxt-layer-base/locales/en.json", load: () => import("../../node_modules/.pnpm/@bttr-nl+nuxt-layer-base@1.0.0-rc.4_nuxt@3.15.4_rollup@4.34.8_tailwindcss@app+@formkit+themes_v2tyvbaulfakoomues5gcm6yja/node_modules/@bttr-nl/nuxt-layer-base/locales/en.json" /* webpackChunkName: "locale____w_gfh_corporate_gfh_corporate_nuxt_node_modules__pnpm__64bttr_nl_43nuxt_layer_base_641_0_0_rc_4_nuxt_643_15_4_rollup_644_34_8_tailwindcss_64app_43_64formkit_43themes_v2tyvbaulfakoomues5gcm6yja_node_modules__64bttr_nl_nuxt_layer_base_locales_en_json" */), cache: true },
{ key: "../../node_modules/.pnpm/@bttr-nl+nuxt-layer-sofie@1.0.0-rc.4_nuxt@3.15.4_react-dom@18.3.1_react@18.3.1_rollup@4.34.8__rquqcm4x5zb2wmahh2kq2ufif4/node_modules/@bttr-nl/nuxt-layer-sofie/locales/en.json", load: () => import("../../node_modules/.pnpm/@bttr-nl+nuxt-layer-sofie@1.0.0-rc.4_nuxt@3.15.4_react-dom@18.3.1_react@18.3.1_rollup@4.34.8__rquqcm4x5zb2wmahh2kq2ufif4/node_modules/@bttr-nl/nuxt-layer-sofie/locales/en.json" /* webpackChunkName: "locale____w_gfh_corporate_gfh_corporate_nuxt_node_modules__pnpm__64bttr_nl_43nuxt_layer_sofie_641_0_0_rc_4_nuxt_643_15_4_react_dom_6418_3_1_react_6418_3_1_rollup_644_34_8__rquqcm4x5zb2wmahh2kq2ufif4_node_modules__64bttr_nl_nuxt_layer_sofie_locales_en_json" */), cache: true },
{ key: "../translations/en-US.json", load: () => import("../translations/en-US.json" /* webpackChunkName: "locale____w_gfh_corporate_gfh_corporate_nuxt_website_translations_en_US_json" */), cache: true }],
  "de": [{ key: "../translations/de-DE.json", load: () => import("../translations/de-DE.json" /* webpackChunkName: "locale____w_gfh_corporate_gfh_corporate_nuxt_website_translations_de_DE_json" */), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "nl",
      "domain": "https://groentenfruithuis.nl",
      "title": "Nederlands",
      "files": [
        "/__w/gfh-corporate/gfh-corporate/nuxt/node_modules/.pnpm/@bttr-nl+nuxt-layer-base@1.0.0-rc.4_nuxt@3.15.4_rollup@4.34.8_tailwindcss@app+@formkit+themes_v2tyvbaulfakoomues5gcm6yja/node_modules/@bttr-nl/nuxt-layer-base/locales/nl.json",
        "/__w/gfh-corporate/gfh-corporate/nuxt/node_modules/.pnpm/@bttr-nl+nuxt-layer-sofie@1.0.0-rc.4_nuxt@3.15.4_react-dom@18.3.1_react@18.3.1_rollup@4.34.8__rquqcm4x5zb2wmahh2kq2ufif4/node_modules/@bttr-nl/nuxt-layer-sofie/locales/nl.json",
        "/__w/gfh-corporate/gfh-corporate/nuxt/website/translations/nl-NL.json"
      ]
    },
    {
      "code": "en",
      "domain": "https://freshproducecentre.com",
      "title": "English",
      "files": [
        "/__w/gfh-corporate/gfh-corporate/nuxt/node_modules/.pnpm/@bttr-nl+nuxt-layer-base@1.0.0-rc.4_nuxt@3.15.4_rollup@4.34.8_tailwindcss@app+@formkit+themes_v2tyvbaulfakoomues5gcm6yja/node_modules/@bttr-nl/nuxt-layer-base/locales/en.json",
        "/__w/gfh-corporate/gfh-corporate/nuxt/node_modules/.pnpm/@bttr-nl+nuxt-layer-sofie@1.0.0-rc.4_nuxt@3.15.4_react-dom@18.3.1_react@18.3.1_rollup@4.34.8__rquqcm4x5zb2wmahh2kq2ufif4/node_modules/@bttr-nl/nuxt-layer-sofie/locales/en.json",
        "/__w/gfh-corporate/gfh-corporate/nuxt/website/translations/en-US.json"
      ]
    },
    {
      "domain": "https://obstgemusehaus.de",
      "code": "de",
      "title": "Deutsch",
      "files": [
        "/__w/gfh-corporate/gfh-corporate/nuxt/website/translations/de-DE.json"
      ]
    }
  ],
  "defaultLocale": "nl",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "no_prefix",
  "lazy": true,
  "langDir": "translations",
  "detectBrowserLanguage": false,
  "differentDomains": true,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "config",
  "pages": {
    "about-us/index": {
      "nl": "/over-ons",
      "en": "/about-us",
      "de": "/uber-uns"
    },
    "about-us/medewerkers": {
      "nl": "/over-ons/medewerkers",
      "en": "/about-us/employees",
      "de": "/uber-uns/personal"
    },
    "about-us/business-councils/index": {
      "nl": "/over-ons/business-councils",
      "en": "/about-us/business-councils",
      "de": "/uber-uns/unternehmensrate"
    },
    "about-us/business-councils/[slug]": {
      "nl": "/over-ons/business-councils/[slug]",
      "en": "/about-us/business-councils/[slug]",
      "de": "/uber-uns/unternehmensrate/[slug]"
    },
    "about-us/committees/index": {
      "nl": "/over-ons/comites",
      "en": "/about-us/committees",
      "de": "/uber-uns/ausschüsse"
    },
    "about-us/committees/[slug]": {
      "nl": "/over-ons/comites/[slug]",
      "en": "/about-us/committees/[slug]",
      "de": "/uber-uns/ausschüsse/[slug]"
    },
    "about-us/networking-clubs/index": {
      "nl": "/over-ons/netwerkclubs",
      "en": "/about-us/networking-clubs",
      "de": "/uber-uns/networking-clubs"
    },
    "about-us/networking-clubs/[slug]": {
      "nl": "/over-ons/netwerkclubs/[slug]",
      "en": "/about-us/networking-clubs/[slug]",
      "de": "/uber-uns/networking-clubs/[slug]"
    },
    "about-us/networking-groups/index": {
      "nl": "/over-ons/netwerkgroepen",
      "en": "/about-us/networking-groups",
      "de": "/uber-uns/netzwerkgruppen"
    },
    "about-us/networking-groups/[slug]": {
      "nl": "/over-ons/netwerkgroepen/[slug]",
      "en": "/about-us/networking-groups/[slug]",
      "de": "/uber-uns/netzwerkgruppen/[slug]"
    },
    "about-us/vacancies/[slug]": {
      "nl": "/over-ons/vacatures/[slug]",
      "en": "/about-us/vacancies/[slug]",
      "de": "/uber-uns/Stellenangebote/[slug]"
    },
    "ambitions/index": {
      "nl": "/ambities",
      "en": "/ambitions",
      "de": "/ambitionen"
    },
    "ambitions/[ambition]/index": {
      "nl": "/ambities/[ambition]",
      "en": "/ambitions/[ambition]",
      "de": "/ambitionen/[ambition]"
    },
    "ambitions/[ambition]/[slug]": {
      "nl": "/ambities/[ambition]/[slug]",
      "en": "/ambitions/[ambition]/[slug]",
      "de": "/ambitionen/[ambition]/[slug]"
    },
    "members/index": {
      "nl": "/leden",
      "en": "/members",
      "de": "/mitglieder"
    },
    "members/[slug]": {
      "nl": "/leden/[slug]",
      "en": "/members/[slug]",
      "de": "/mitglieder/[slug]"
    },
    "news/index": {
      "nl": "/nieuws",
      "en": "/news",
      "de": "/nachrichten"
    },
    "news/[slug]": {
      "nl": "/nieuws/[slug]",
      "en": "/news/[slug]",
      "de": "/nachrichten/[slug]"
    },
    "contact": {
      "nl": "/contact",
      "en": "/contact",
      "de": "/kontakt"
    },
    "events/index": {
      "nl": "/agenda",
      "en": "/events",
      "de": "/ereignisse"
    },
    "events/[slug]": {
      "nl": "/agenda/[slug]",
      "en": "/events/[slug]",
      "de": "/veranstaltungen/[slug]"
    },
    "search": {
      "nl": "/zoeken",
      "en": "/search",
      "de": "/süchen"
    }
  },
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "fallbackLocale": "en",
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "nl",
    "domain": "https://groentenfruithuis.nl",
    "title": "Nederlands",
    "files": [
      {
        "path": "/__w/gfh-corporate/gfh-corporate/nuxt/node_modules/.pnpm/@bttr-nl+nuxt-layer-base@1.0.0-rc.4_nuxt@3.15.4_rollup@4.34.8_tailwindcss@app+@formkit+themes_v2tyvbaulfakoomues5gcm6yja/node_modules/@bttr-nl/nuxt-layer-base/locales/nl.json"
      },
      {
        "path": "/__w/gfh-corporate/gfh-corporate/nuxt/node_modules/.pnpm/@bttr-nl+nuxt-layer-sofie@1.0.0-rc.4_nuxt@3.15.4_react-dom@18.3.1_react@18.3.1_rollup@4.34.8__rquqcm4x5zb2wmahh2kq2ufif4/node_modules/@bttr-nl/nuxt-layer-sofie/locales/nl.json"
      },
      {
        "path": "/__w/gfh-corporate/gfh-corporate/nuxt/website/translations/nl-NL.json"
      }
    ]
  },
  {
    "code": "en",
    "domain": "https://freshproducecentre.com",
    "title": "English",
    "files": [
      {
        "path": "/__w/gfh-corporate/gfh-corporate/nuxt/node_modules/.pnpm/@bttr-nl+nuxt-layer-base@1.0.0-rc.4_nuxt@3.15.4_rollup@4.34.8_tailwindcss@app+@formkit+themes_v2tyvbaulfakoomues5gcm6yja/node_modules/@bttr-nl/nuxt-layer-base/locales/en.json"
      },
      {
        "path": "/__w/gfh-corporate/gfh-corporate/nuxt/node_modules/.pnpm/@bttr-nl+nuxt-layer-sofie@1.0.0-rc.4_nuxt@3.15.4_react-dom@18.3.1_react@18.3.1_rollup@4.34.8__rquqcm4x5zb2wmahh2kq2ufif4/node_modules/@bttr-nl/nuxt-layer-sofie/locales/en.json"
      },
      {
        "path": "/__w/gfh-corporate/gfh-corporate/nuxt/website/translations/en-US.json"
      }
    ]
  },
  {
    "domain": "https://obstgemusehaus.de",
    "code": "de",
    "title": "Deutsch",
    "files": [
      {
        "path": "/__w/gfh-corporate/gfh-corporate/nuxt/website/translations/de-DE.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
